export default {
  ACTUAL: 'interval-type-actual',
  THEORETICAL: 'interval-type-theoretical'
}



// WEBPACK FOOTER //
// ./src/interval-types.js